import type { LawyerPositionList } from '@shared/types/lawyer-position';
import { api } from './client';

/// 役職マスタの読み取り。 弁護士の作成/詳細編集モーダルと一覧フィルタで
/// 選択肢候補に使う。
export const lawyerPositionsApi = {
  list(): Promise<LawyerPositionList> {
    return api.get<LawyerPositionList>('/api/lawyer-positions');
  },
};
